export default (props = {}) => <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<g filter="url(#filter0_d_14_8141)">
<path d="M2 9C2 4.58172 5.58172 1 10 1H34C38.4183 1 42 4.58172 42 9V33C42 37.4183 38.4183 41 34 41H10C5.58172 41 2 37.4183 2 33V9Z" fill="white" shape-rendering="crispEdges"/>
<path d="M2.5 9C2.5 4.85786 5.85786 1.5 10 1.5H34C38.1421 1.5 41.5 4.85786 41.5 9V33C41.5 37.1421 38.1421 40.5 34 40.5H10C5.85786 40.5 2.5 37.1421 2.5 33V9Z" stroke="#D1D1DB" shape-rendering="crispEdges"/>
<path d="M14.75 23.75V25.25C14.75 26.9069 16.0931 28.25 17.75 28.25H26.25C27.9069 28.25 29.25 26.9069 29.25 25.25V23.75M22 23.25V14M18.75 17.25L22 13.75L25.25 17.25" stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_d_14_8141" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0901961 0 0 0 0.05 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14_8141"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14_8141" result="shape"/>
</filter>
</defs>
</svg>
